// extracted by mini-css-extract-plugin
module.exports = {"label":"label_label__21lcP"};